<template>
  <Popup v-model="show" round position="bottom" get-container="body" close-on-popstate>
    <div class="time-list">
      <span class="title">订单号：{{ orderNo }}</span>
      <div class="scroll-box">
        <div v-for="item, index in logList" :key="index">
          <span :style="index == 0 ? 'color: #FF6634' : ''">{{ item }}</span>
          <i class="icon" :class="{icon2: index == 0}"></i>
          <i class="line" :class="{line2: index == 0}" v-if="index + 1 < logList.length"></i>
        </div>
      </div>
      <div class="btn-box">
        <van-button class="btn" type="primary" @click="show = false">我知道了</van-button>
      </div>
    </div>

  </Popup>
</template>

<script>
import { Popup } from 'vant';
export default {
  props: {
    value: [Boolean],
    orderNo: [String],
    logList: [Array]
  },
  data() {
    return {
      show: false,
      showError: true,
      addressData: {}
    }
  },
  watch: {
    value(val) {
      this.show = val;
      if (val) {
        this.showError = false;
        if (!this.data.seq) {
          //新增设置默认值
          this.data = {
            cname: '',
            cmobile: '',
            daddr: '',
            dflag: 1,
          }
        }
        this.addressData = JSON.parse(JSON.stringify(this.data))
      }
    },
    show(val) {
      if (!val) {
        this.$emit('input', false);
      }
    }
  },
  created() {
  },
  components: {
    Popup
  },
  computed: {
  },
  methods: {

  }
}
</script>

<style scoped lang="less">
.time-list {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  min-height: 60vh;

  .title {
    height: 108px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #E5E6EB;
    color: #333;
    font-size: 32px;
    font-style: normal;
    font-weight: bold;
  }

  .scroll-box {
    overflow-y: scroll;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-top: 52px;

    >div {
      display: flex;
      position: relative;
      padding-left: 96px;

      >span {
        color: #666;
        font-size: 32px;
        font-style: normal;
        font-weight: 400;
        line-height: 44px;
        margin-bottom: 36px;
      }

      .icon {
        width: 22px;
        height: 22px;
        border: 5px solid #666;
        position: absolute;
        left: 52px;
        top: 12px;
        border-radius: 18px;
      }

      .icon2{

        border: 5px solid #FF6634;
      }

      .line{
        width: 3px;
        height: 46px;
        position: absolute;
        top: 40px;
        left:  61px;
        background: #DDD;
      }

      .line2{
        background: #FF6634;
      }
    }
  }

  .btn-box {
    height: 120px;
    display: flex;
    background: #fff;
    align-items: center;

    .btn {
      margin: 0 30px;
      height: 88px;
      flex: 1;
      border-radius: 8px;
      font-size: 34px;
    }
  }
}
</style>
